module.exports = __webpack_public_path__ + "img/category-chemical.66db43cc.svg";